import React, { createContext, useState } from "react";

const TailoringContext = createContext();

export const TailoringProvider = ({ children }) => {
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [customOrder, setCustomOrder] = useState(null);
  const [customOrderRes, setCustomOrderRes] = useState(null);
  const [customOrderID, setCustomOrderID] = useState(null);

  const taloringValues = {
    loader,
    setLoader,
    customOrder,
    setCustomOrder,
    customOrderRes,
    setCustomOrderRes,
    customOrderID,
    setCustomOrderID,
    errorMessage,
    setErrorMessage,
  };
  return (
    <TailoringContext.Provider value={taloringValues}>
      {children}
    </TailoringContext.Provider>
  );
};

export default TailoringContext;
